
import fetchType from './fetchType'
import currentPeriod from './currentPeriod'

export default {
  fetchType,
  currentPeriod,
}


// WEBPACK FOOTER //
// ./src/services/user/index.js